// extracted by mini-css-extract-plugin
export default {"notificationsIcon":"NotificationsIcon_notificationsIcon__QOxSk","hidden":"NotificationsIcon_hidden__zm7N-"};